import React, { Fragment } from 'react';

const RechargeVehicleCost = () => (
  <Fragment>
    <p>
      Charging from 0-100% at a Tesla Supercharger costs approximately
      $25-35, and takes 30-45 minutes. Vehicles are to be returned with at
      least 70% at the end of the booking.
    </p>
    <br />
  </Fragment>
);

export default RechargeVehicleCost;



// WEBPACK FOOTER //
// ./src/components/Static/DriverFaq/General/RechargeVehicleCost.js